import { AppConfig } from ".";

export const localConfig: AppConfig = {
    apiUrl: 'http://localhost:8080',
    dashboardUrl: 'http://localhost:3000',
    firebaseConfig: {
        apiKey: "AIzaSyBHu6YHUwA3pF6JdUz3KvGSD8mBx2cbhPM",
        authDomain: "padelfzco-admin.firebaseapp.com",
        projectId: "padelfzco-admin",
        storageBucket: "padelfzco-admin.firebasestorage.app",
        messagingSenderId: "274485321979",
        appId: "1:274485321979:web:f910fc26182c09b08f105e"
    },
};